/* SUMOCAT — interacciones y animaciones (vanilla, sin librerías) */
(function () {
  'use strict';
  document.documentElement.classList.add('sc-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Titulares palabra a palabra ---------- */
  function initSplit(root) {
    (root || document).querySelectorAll('[data-sc-split]:not([data-sc-split-ok])').forEach(function (el) {
      el.setAttribute('data-sc-split-ok', '');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'sc-palabra';
              var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = part;
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !n.matches('svg, br')) {
            if (n.classList.contains('sc-subrayado')) {
              var w2 = document.createElement('span'); w2.className = 'sc-palabra';
              var s2 = document.createElement('span'); s2.style.setProperty('--i', i++);
              n.parentNode.insertBefore(w2, n); s2.appendChild(n); w2.appendChild(s2);
              w2.style.overflow = 'visible';
            } else { walk(n); }
          }
        });
      })(el);
      el.classList.add('sc-split');
    });
  }

  /* ---------- Revelado al hacer scroll (un único observer) ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sc-reveal, .sc-clip, [data-sc-split], [data-sc-observe]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('sc-visible'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('sc-visible');
            en.target.dispatchEvent(new CustomEvent('sc:visible'));
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (e) { if (!e.classList.contains('sc-visible')) io.observe(e); });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  function initParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-sc-parallax]'));
    if (reduce || !parallaxEls.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-sc-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetic() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-sc-magnet]').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.28;
        b.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Inclinación 3D de tarjetas ---------- */
  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-sc-tilt]').forEach(function (c) {
      var max = parseFloat(c.getAttribute('data-sc-tilt')) || 6;
      c.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Anatomía: líneas que conectan notas y puntos ---------- */
  function initAnatomia(root) {
    (root || document).querySelectorAll('[data-sc-anat]').forEach(function (sec) {
      var stage = sec.querySelector('.sc-anat__escenario');
      var svg = sec.querySelector('.sc-anat__lineas');
      if (!stage || !svg) return;
      var notas = sec.querySelectorAll('.sc-anat__nota');
      function draw() {
        if (window.innerWidth < 990) return;
        var sr = stage.getBoundingClientRect();
        svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);
        var html = '';
        notas.forEach(function (n) {
          var p = sec.querySelector('.sc-anat__punto[data-k="' + n.getAttribute('data-k') + '"]');
          var num = n.querySelector('.sc-anat__num');
          if (!p || !num) return;
          var a = num.getBoundingClientRect(), b = p.getBoundingClientRect();
          var izq = n.closest('.sc-anat__col--izq');
          var x1 = (izq ? a.right + 10 : a.left - 10) - sr.left, y1 = a.top + a.height / 2 - sr.top;
          var x2 = b.left + b.width / 2 - sr.left, y2 = b.top + b.height / 2 - sr.top;
          var mx = x1 + (x2 - x1) * 0.55;
          html += '<path data-k="' + n.getAttribute('data-k') + '" d="M' + x1 + ',' + y1 + ' C' + mx + ',' + y1 + ' ' + mx + ',' + y2 + ' ' + x2 + ',' + y2 + '"/>';
        });
        svg.innerHTML = html;
      }
      function activar(k, on) {
        sec.querySelectorAll('[data-k="' + k + '"]').forEach(function (e) { e.classList.toggle('is-activa', on); });
      }
      sec.querySelectorAll('.sc-anat__nota, .sc-anat__punto').forEach(function (el) {
        el.addEventListener('mouseenter', function () { activar(el.getAttribute('data-k'), true); });
        el.addEventListener('mouseleave', function () { activar(el.getAttribute('data-k'), false); });
      });
      draw();
      window.addEventListener('resize', draw);
      var img = sec.querySelector('.sc-anat__marco img');
      if (img && !img.complete) img.addEventListener('load', draw);
      setTimeout(draw, 1300); setTimeout(draw, 2600);
      // Recorrido automático de las notas cuando entra en pantalla
      var fig = sec.querySelector('.sc-anat__figura');
      if (fig && !reduce) fig.addEventListener('sc:visible', function () {
        var ks = Array.prototype.map.call(notas, function (n) { return n.getAttribute('data-k'); });
        ks.forEach(function (k, i) {
          setTimeout(function () { activar(k, true); }, 900 + i * 450);
          setTimeout(function () { activar(k, false); }, 1400 + i * 450);
        });
      });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras(root) {
    (root || document).querySelectorAll('[data-sc-count]').forEach(function (el) {
      var fin = parseFloat(el.getAttribute('data-sc-count')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toFixed(dec).replace('.', ','); return; }
      el.textContent = (0).toFixed(dec).replace('.', ',');
      el.setAttribute('data-sc-observe', '');
      el.addEventListener('sc:visible', function () {
        var t0 = null, dur = 1800;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4);
          el.textContent = (fin * e).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparador(root) {
    (root || document).querySelectorAll('[data-sc-comp]').forEach(function (c) {
      var activo = false;
      function mover(clientX) {
        var r = c.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
        c.style.setProperty('--pos', p + '%');
        c.classList.add('is-tocado');
      }
      c.addEventListener('pointerdown', function (e) { activo = true; mover(e.clientX); });
      window.addEventListener('pointerup', function () { activo = false; });
      c.addEventListener('pointermove', function (e) { if (activo || e.pointerType === 'mouse') mover(e.clientX); });
      c.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(c).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') c.style.setProperty('--pos', Math.max(0, cur - 5) + '%');
        if (e.key === 'ArrowRight') c.style.setProperty('--pos', Math.min(100, cur + 5) + '%');
      });
      // Pequeña demostración al entrar en pantalla
      c.setAttribute('data-sc-observe', '');
      c.addEventListener('sc:visible', function () {
        if (reduce || c.classList.contains('is-tocado')) return;
        var t0 = null;
        function anim(t) {
          if (!t0) t0 = t;
          var p = (t - t0) / 2200;
          if (p >= 1 || c.classList.contains('is-tocado')) { if (!c.classList.contains('is-tocado')) c.style.setProperty('--pos', '50%'); return; }
          c.style.setProperty('--pos', (50 + Math.sin(p * Math.PI * 2) * 22) + '%');
          requestAnimationFrame(anim);
        }
        setTimeout(function () { requestAnimationFrame(anim); }, 500);
      });
    });
  }

  /* ---------- Acordeones con altura animada ---------- */
  function initAcordeones(root) {
    (root || document).querySelectorAll('.sc-acc').forEach(function (d) {
      if (d.hasAttribute('data-sc-acc-ok')) return;
      d.setAttribute('data-sc-acc-ok', '');
      var s = d.querySelector('summary'), body = d.querySelector('.sc-acc__cuerpo');
      if (!s || !body || reduce) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          setTimeout(function () { d.open = false; body.style.height = ''; }, 480);
        } else {
          d.open = true;
          var h = body.scrollHeight; body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = h + 'px'; });
          setTimeout(function () { body.style.height = ''; }, 520);
        }
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-sc-pdp]').forEach(function (pdp) {
      // Galería
      var slides = pdp.querySelectorAll('.sc-pdp__slide'), minis = pdp.querySelectorAll('.sc-pdp__mini');
      var idx = 0;
      function ir(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-activa', k === idx); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === idx); });
        if (minis[idx] && minis[idx].scrollIntoView && window.innerWidth < 990) minis[idx].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var prev = pdp.querySelector('[data-sc-prev]'), next = pdp.querySelector('[data-sc-next]');
      if (prev) prev.addEventListener('click', function () { ir(idx - 1); });
      if (next) next.addEventListener('click', function () { ir(idx + 1); });
      var principal = pdp.querySelector('.sc-pdp__principal');
      if (principal) {
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(idx + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      // Cantidad
      var cant = pdp.querySelector('.sc-cant input');
      pdp.querySelectorAll('[data-sc-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-sc-cant'), 10));
          cant.value = v;
        });
      });

      // Variantes
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var dataEl = pdp.querySelector('[data-sc-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var precioEl = pdp.querySelector('[data-sc-precio]'), tachadoEl = pdp.querySelector('[data-sc-tachado]');
      var botones = pdp.querySelectorAll('[data-sc-add]');
      var barraPrecio = pdp.querySelector('[data-sc-barra-precio]');
      var formato = pdp.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      function money(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var sel = Array.prototype.map.call(pdp.querySelectorAll('[data-sc-opcion]'), function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
        var v = variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { botones.forEach(function (b) { b.disabled = true; }); return; }
        idInput.value = v.id;
        if (precioEl) precioEl.textContent = money(v.price);
        if (barraPrecio) barraPrecio.textContent = money(v.price);
        if (tachadoEl) { tachadoEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('.sc-btn__texto');
          if (t) t.textContent = v.available ? b.getAttribute('data-txt-ok') : b.getAttribute('data-txt-agotado');
        });
        if (v.featured_media) {
          var k = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media') == v.featured_media.id; });
          if (k > -1) ir(k);
        }
      }
      pdp.querySelectorAll('[data-sc-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      // Añadir al carrito con el cajón de Dawn (con respaldo de envío normal)
      if (form) form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!window.fetch) return;
        e.preventDefault();
        var aviso = pdp.querySelector('.sc-pdp__aviso');
        botones.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.style.opacity = '.75'; });
        var fd = new FormData(form);
        if (cant) fd.set('quantity', cant.value);
        if (drawer && drawer.getSectionsToRender) {
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (aviso) aviso.textContent = res.description || res.message; return; }
          if (aviso) aviso.textContent = '';
          if (drawer && drawer.renderContents) {
            drawer.renderContents(res);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function () { form.submit(); })
          .finally(function () { botones.forEach(function (b) { b.removeAttribute('aria-busy'); b.style.opacity = ''; }); });
      });

      // Barra fija de compra en móvil
      var barra = pdp.querySelector('.sc-pdp__barra'), compra = pdp.querySelector('.sc-pdp__compra');
      if (barra && compra && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(compra);
        var bb = barra.querySelector('[data-sc-barra-btn]');
        if (bb) bb.addEventListener('click', function () {
          var b = form.querySelector('[data-sc-add]'); if (b && !b.disabled) form.requestSubmit ? form.requestSubmit(b) : b.click();
        });
      }
    });
  }

  /* ---------- Marquesinas: duplicar contenido para bucle perfecto ---------- */
  function initMarquesinas(root) {
    (root || document).querySelectorAll('[data-sc-marq]').forEach(function (fila) {
      if (fila.hasAttribute('data-sc-marq-ok')) return;
      fila.setAttribute('data-sc-marq-ok', '');
      var pista = fila.querySelector('[data-sc-pista]');
      if (!pista) return;
      var copias = Math.max(1, Math.ceil((window.innerWidth * 1.2) / Math.max(pista.scrollWidth, 1)));
      for (var i = 0; i < copias; i++) { var c = pista.cloneNode(true); c.setAttribute('aria-hidden', 'true'); fila.appendChild(c); }
    });
  }

  function initTodo(root) {
    initSplit(root); initMarquesinas(root); initCifras(root); initComparador(root);
    initAcordeones(root); initAnatomia(root); initProducto(root); initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document); initParallax(); initMagnetic(); initTilt();
  });
  // Editor de Shopify: re-inicializar al editar una sección
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); initParallax(); });
})();
